// Client du journal alimentaire (POST/GET /api/journal, GET /api/journal/export.csv). Même parti
// pris que uploadClient.ts/analyzeClient.ts : pas d'en-tête d'auth ajouté ici — Cloudflare Access
// pose son cookie sur tout le domaine une fois l'utilisateur connecté, il part avec chaque requête
// same-origin sans rien à faire côté client (CLAUDE.md § Auth : proxy même origine).
import type { JournalEntry, JournalListResponse, JournalRequest } from './types.js';

export class JournalError extends Error {}

export interface OptionsJournal {
  baseUrl?: string;
  signal?: AbortSignal;
  fetchImpl?: typeof fetch;
}

export async function enregistrerRepas(
  requete: JournalRequest,
  options: OptionsJournal = {},
): Promise<JournalEntry> {
  const fetchImpl = options.fetchImpl ?? fetch;
  let reponse: Response;
  try {
    reponse = await fetchImpl(`${options.baseUrl ?? ''}/api/journal`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requete),
      signal: options.signal,
    });
  } catch {
    throw new JournalError("Impossible de joindre NutriScan : vérifie ta connexion, puis réessaie.");
  }
  if (!reponse.ok) {
    throw new JournalError("L'enregistrement du repas a échoué. Réessaie dans un instant.");
  }
  const corps = (await reponse.json()) as { enregistre: JournalEntry };
  return corps.enregistre;
}

/** Sans `jour` : historique récent. Avec `jour` (YYYY-MM-DD) : les repas de ce jour + `totauxJour`. */
export async function chargerJournal(
  params: { jour?: string; limite?: number } = {},
  options: OptionsJournal = {},
): Promise<JournalListResponse> {
  const fetchImpl = options.fetchImpl ?? fetch;
  const recherche = new URLSearchParams();
  if (params.jour) recherche.set('jour', params.jour);
  if (params.limite) recherche.set('limite', String(params.limite));
  const qs = recherche.toString();

  let reponse: Response;
  try {
    reponse = await fetchImpl(`${options.baseUrl ?? ''}/api/journal${qs ? `?${qs}` : ''}`, {
      signal: options.signal,
    });
  } catch {
    throw new JournalError("Impossible de joindre NutriScan : vérifie ta connexion, puis réessaie.");
  }
  if (!reponse.ok) {
    throw new JournalError('La lecture du journal a échoué.');
  }
  return (await reponse.json()) as JournalListResponse;
}

/** URL de l'export CSV — un simple lien `<a href>` suffit, la navigation porte le cookie Access. */
export function urlExportCsv(params: { depuis?: string; jusqua?: string } = {}): string {
  const recherche = new URLSearchParams();
  if (params.depuis) recherche.set('depuis', params.depuis);
  if (params.jusqua) recherche.set('jusqua', params.jusqua);
  const qs = recherche.toString();
  return `/api/journal/export.csv${qs ? `?${qs}` : ''}`;
}

/** Date du jour au format YYYY-MM-DD, dans le fuseau du navigateur (pas UTC) : « aujourd'hui »
 *  doit correspondre à la journée que l'utilisateur vient de vivre, pas à celle du serveur. */
export function aujourdhui(): string {
  const maintenant = new Date();
  const mois = String(maintenant.getMonth() + 1).padStart(2, '0');
  const jour = String(maintenant.getDate()).padStart(2, '0');
  return `${maintenant.getFullYear()}-${mois}-${jour}`;
}
